// mui 5
import { styled } from "@mui/material/styles";
import Box from "@mui/system/Box";

export const StyledFilledCart = styled(Box)(({ theme }) => ({
  // ---DEBUG---
  // border: '2px dashed black'
}));

export const StyledCartItems = styled(Box)(({ theme }) => ({
  // ---DEBUG---
  // border: '2px dashed red'
}));

export const StyledCartSummary = styled(Box)(({ theme }) => ({
  display: "flex",
  marginTop: theme.spacing(2),
  width: "100%",
  justifyContent: "space-between",
  // ---DEBUG---
  // border: '2px dashed red'
}));

export const StyledCartActions = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",

  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
  // ---DEBUG---
  // border: '2px dashed red'
}));
